import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, Lock } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface MenuWatermarkProps {
  onActivate?: () => void;
}

const MenuWatermark: React.FC<MenuWatermarkProps> = ({ onActivate }) => {
  return (
    <>
      {/* Top banner */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-r from-red-500 to-orange-500 text-white px-4 py-3"
      >
        <div className="flex items-center justify-center gap-3 max-w-4xl mx-auto">
          <AlertTriangle className="w-5 h-5 shrink-0" />
          <span className="text-sm font-medium">
            Menu en mode prévisualisation - Non visible par vos clients
          </span>
          {onActivate && (
            <Button
              onClick={onActivate}
              size="sm"
              variant="secondary"
              className="ml-2 bg-white/20 hover:bg-white/30 text-white border-0"
            >
              Activer maintenant
            </Button>
          )}
        </div>
      </motion.div>

      {/* Diagonal watermark overlay */}
      <div className="fixed inset-0 pointer-events-none z-40 overflow-hidden">
        <div className="absolute inset-0 flex items-center justify-center">
          <div 
            className="text-red-500/10 font-bold text-6xl md:text-8xl whitespace-nowrap select-none"
            style={{ 
              transform: 'rotate(-35deg)',
              textShadow: '0 0 20px rgba(239, 68, 68, 0.1)'
            }}
          >
            NON ACTIVÉ • NON ACTIVÉ • NON ACTIVÉ
          </div>
        </div>
      </div>

      {/* Bottom floating activation button */}
      {onActivate && (
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1 }}
          className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50"
        >
          <Button
            onClick={onActivate}
            size="lg"
            className="bg-gradient-to-r from-orange-500 to-amber-500 hover:from-orange-600 hover:to-amber-600 shadow-2xl text-white font-bold px-8 py-6 rounded-full"
          >
            <Lock className="w-5 h-5 mr-2" />
            Activer mon menu - 14 jours gratuits
          </Button>
        </motion.div>
      )}
    </>
  );
};

export default MenuWatermark;
